
interface PathParam {
  modifier: '' | '*' | '+' | '?';
  name: string;
}

type PathToken = string | PathParam;

export function stringifyRoute(
  template: string,
  params: Record<string, string>,
) {
  const prefixPath = '';

  const pathTokens = parseTokens(template.split('/'));
  return (('/')
    + (prefixPath ? (prefixPath === '/' ? [''] : [prefixPath]) : []).concat(pathTokens.reduce<string[]>(
      (acc, t) =>
        isPathParam(t)
          ? (
            params[t.name] ? acc.concat(encodeURIComponent(params[t.name])) : acc
          )
          : (
            acc.concat(t)
          ),
      [],
    ))
      .join('/'));
}

function parseTokens(template: string[]): PathToken[] {
  return template.reduce<PathToken[]>((acc, f) => {
    if (!f) {
      return acc;
    } else if (f.startsWith(':')) {
      const maybeMod = f[f.length - 1];
      const modifier = maybeMod === '+' || maybeMod === '*' || maybeMod === '?'
        ? maybeMod
        : '';
      return acc.concat({
        modifier,
        name: f.slice(1, modifier ? f.length - 1 : undefined),
      });
    }
    return acc.concat(f);
  }, []);
}

function isPathParam(x: PathToken): x is PathParam {
  return typeof x !== 'string';
}
